import React from 'react'
import { Elements, RecurlyProvider } from '@recurly/react-recurly'
import { RecurlyModal } from './recurly-modal'

export const RecurlyModalContainer = () => {
  return (
    <RecurlyProvider publicKey={process.env.RECURLY_PUBLIC_KEY!}>
      <Elements>
        <RecurlyModal />
      </Elements>
    </RecurlyProvider>
  )
}
